import { Stack, Typography } from '@mui/material';
import { AuditInformation} from '@store/audits/audits-information/audits-information.model';


interface DataProps {
    auditInformation: AuditInformation;
}

const Data = (props: DataProps) => {
    const {auditInformation} = props;
    return (
        <Stack direction="row" alignItems="center" height="100%" spacing={4}>
            <Stack sx={{
                backgroundColor: '#E9EBEE',
                borderRadius: '1px',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '6px 10px',
            }}>
                <Typography fontSize="12px" fontWeight={400} color="#192133">
                    {auditInformation?.legend || '-'}
                </Typography>
            </Stack>
            <Stack direction="row" alignItems="center" spacing={1.5}>
                <Typography fontSize="14px" fontWeight={400} color="#868F9C">
                    donnée
                </Typography>
                <Stack sx={{
                    backgroundColor: '#E9EBEE',
                    borderRadius: '1px',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '6px 10px',
                }}>
                    <Typography fontSize="12px" fontWeight={400} color="#192133">
                        {auditInformation.description || '-'}{auditInformation?.data}
                    </Typography>
                </Stack>
            </Stack>
        </Stack>
    );
};

export default Data;
